export default "__VITE_ASSET__264ccc04__"